import UserRole from './UserRole';

export class PsUserRole {

    _id;
    _description;

    constructor(id, description) {
        this._id = id;
        this._description = description;
    }

    static fromInvalid() {
        return new this(-1, '');
    }

    static fromBackend(role) {
        return new this(role.id, role.name);
    }

    id() {
        return this._id;
    }

    description() {
        return this._description;
    }

    isSuperAdmin() {
        return this.id() === UserRole.SUPERADMIN;
    }

    isAdmin() {
        return this.id() === UserRole.ADMIN;
    }

    isOutsourcesManager() {
        return this.id() === UserRole.OUTSOURCES_MANAGER;
    }

    isOutsourcesViewer() {
        return this.id() === UserRole.OUTSOURCES_VIEWER;
    }

    isContractorsManager() {
        return this.id() === UserRole.CONTRACTORS_MANAGER;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/PsUserRole.js